module.exports = __webpack_public_path__ + "static/media/ua2.30695a41.png";